<template>
  <!-- 快速预约 -->
  <div v-if="loading" class="bg-white mar-top pad-ver">
    <van-skeleton title :row="10"></van-skeleton>
  </div>
  <div v-else class="mar-top">
    <div v-if="roomDoc.isDisabled">
      <empty-notice :desc="`${roomTitle}不可预约`"></empty-notice>
      <p class="text-center text-underline fixed-btn pad-btm-20" @click="handleDetail(1)">查看更多{{roomTitle}} ></p>
    </div>
    <div v-else-if="roomDoc.roomNum">
      <van-cell-group :title="roomDoc.roomNum">
        <!-- 判断会议室状态 -->
        <van-cell v-show="meetingNtcTitle" :title="meetingNtcTitle"></van-cell>
        <!--<van-cell v-show="!suggestions.length" title="" label="暂无空余时间可快速预约"></van-cell>-->
        <van-cell v-for="ele in suggestions" :key="ele.endSlot" center
                  :title="`快速预约 ${ele.hours} 小时`"
                  :label="`${ele.startTime} - ${ele.endTime}`">
          <template>
            <van-button type="primary" size="small" @click="submitReserve(ele)">立即预约</van-button>
          </template>
        </van-cell>
      </van-cell-group>

      <empty-notice v-show="!suggestions.length" :image="'meeting'" :desc="'暂无空余时间可快速预约~'"></empty-notice>

      <p class="text-center text-underline fixed-btn pad-btm-20" @click="handleDetail()">更多预约信息 ></p>
    </div>
    <div v-else class="mar-hor">
      <empty-notice :desc="expired? '二维码已失效' : '暂无内容'"></empty-notice>
    </div>
  </div>
</template>

<script>
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {
    checkRespCorrect, checkShowPermit,
    checkTsExpired,
    frontConfirm,
    getDateBySlot,
    getReservedSlotsByTime,
    getSlotByDate,
    getTimeBySlot
  } from "../../../../tools/utils";
  import {commonConfig} from "../../../../config/common";
  import {meeting, meetingRoom} from "../../../../server"
  import routerMeta from "../../router/routerMeta";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";

  export default {
    data() {
      return {
        rid: "",
        loading: true,
        mgrRoomId: "",
        roomDoc: {},
        expired: false,
        curDate: moment().startOf('day').valueOf(),
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      selfMinSlot() {
        return getSlotByDate(new Date())
      },
      reservedSlots() {
        return getReservedSlotsByTime(this.roomDoc.available || {})
      },
      nextMStartSlot() {
        const sfSlot = this.selfMinSlot;
        return this.reservedSlots.find(slt => slt >= sfSlot);
      },
      meetingNtcTitle() {
        const {reservedTime} = this.roomDoc.available || {};
        if (reservedTime && reservedTime.length) {
          const curDateMm = moment().startOf('m');
          const inMeeting = reservedTime.some(e => {
            return moment(e.start).diff(curDateMm, 'm') < 0 && moment(e.end).diff(curDateMm, 'm') > 0
          });
          if (inMeeting) return "会议进行中";
          const lastTime = reservedTime[reservedTime.length - 1];
          if (moment(lastTime.end).diff(curDateMm, 'm') < 0) return ""
        }
        if (this.nextMStartSlot) {
          const time = getTimeBySlot(this.nextMStartSlot);
          return `下一场会议 ${time} 召开`
        }
      },
      suggestions() {
        const data = [];
        const sfSlotSbt = this.selfMinSlot;
        if (this.nextMStartSlot === this.selfMinSlot && this.reservedSlots.includes(sfSlotSbt)) {
          return data
        }
        const destSlot = this.nextMStartSlot || commonConfig.slotRange.maxSlot;
        // console.log(sfSlot, destSlot);
        if (destSlot > sfSlotSbt) {
          let idx = 1;
          const startTime = getTimeBySlot(sfSlotSbt) || "00:00";
          while ((idx + sfSlotSbt) <= destSlot && idx < 5) {
            data.push({
              startSlot: sfSlotSbt,
              endSlot: sfSlotSbt + idx,
              startTime,
              endTime: getTimeBySlot(sfSlotSbt + idx),
              hours: idx / (60 / commonConfig.unitSlotMinute),
            });
            idx++
          }
        }
        // console.log(data)
        return data
      },
      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          directReserve: checkShowPermit(permissionList, this.permitsMap.directReserve),
        }
      },
    },
    created() {
      // console.log(this.$route.name);
      this.mgrRoomId = this.$route.params.mgrid;
      // if (this.mgrRoomId && checkTsExpired.call(this)) {
      //   this.loading = false;
      //   return
      // }
      this.rid = this.$route.params.rid;
      this.initRoomDoc();
    },
    methods: {
      // 初始化会议室信息
      initRoomDoc() {
        UILoader.load();
        const filter = {date: this.curDate};
        if (this.mgrRoomId) {
          filter.mgrRoomId = this.mgrRoomId
        } else {
          filter.selfCursor = this.rid
        }
        meetingRoom.queryList(this, {queryFilter: filter, queryAll: true}).then(({searchRoom: data = {}}) => {
          UILoader.unload();
          this.loading = false;
          const [edge] = (data.roomEdges || []);
          if (edge && edge.room) {
            this.rid = edge.cursor;
            this.roomDoc = edge.room;
          } else {
            vtToast(`${this.roomTitle}不存在`)
          }
        }).catch(err => {
          UILoader.unload();
          this.loading = false;
          // console.log(err);
          vtToast(err.message)
        });
      },
      submitReserve(info) {
        const destData = {
          subject: getStorage(StorageKey.username) + "的会议",
          startTime: getDateBySlot(info.startSlot, this.curDate).valueOf(),
          endTime: getDateBySlot(info.endSlot, this.curDate).valueOf(),
          reserveWay: commonConfig.reserveWays.scanCode.value
        };
        if (!this.showPermits.directReserve) {
          this.$store.commit('setReserveInfo', {
            ...destData,
            meetingRooms: [{...this.roomDoc, roomId: this.rid}],
          });
          this.$router.push({
            name: routerMeta.meetingReserveFromRoom.name,
            params: {rid: this.rid},
          });
          return
        }
        frontConfirm({msg: `是否确认预定 ${this.roomDoc.name}\n${info.startTime}-${info.endTime} 的会议？`}, () => {
          // console.log(destData);
          meeting.reserveMeeting(this, {
            meeting: {
              ...destData,
              numberOfPeople: 1, // 快速预约 参会人数默认为1
              insideParticipant: [getStorage(StorageKey.userId)],
              meetingRooms: [{id: this.rid}],
              deviceRequire: [],  // 仅作为填充参数
              outsideParticipant: [],  // 仅作为填充参数
            }
          }).then(({newMeeting: res = {}}) => {
            if (checkRespCorrect(res, "保存失败")) {
              this.directCheckin(res.insertId)
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        })
      },
      // 签到
      directCheckin(mid) {
        meeting.checkInMeeting(this, {mid: mid}).then(res => {
          // UILoader.unload();
          messageHdl({code: msgCode.SUCCESS});
          this.$router.push({
            name: routerMeta.meetingDetailFromRoom.name,
            params: {mid: mid, rid: this.rid},
          })
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      handleDetail(list) {
        if (list) {
          this.$router.push({name: routerMeta.roomList.name});
          return
        }
        this.$store.commit('setReserveInfo', {
          meetingRooms: [{
            ...this.roomDoc,
            roomId: this.rid,
          }]
        });
        this.$router.push({name: routerMeta.meetingReserveFromRoom.name, params: {rid: this.rid}})
      },
    }
  }
</script>

<style scoped>
</style>
